// GROW-80 item 3: send the anonymous Mixpanel distinct_id at signup so the backend
// can persist it against the account — needed for Mixpanel identity continuity
// (stitching pre-signup activity to the user once $user_id is set).
import mixpanel from 'mixpanel-browser';

export function getMpDistinctId() {
  try {
    const id = mixpanel?.get_distinct_id?.();
    return id ? String(id) : undefined;
  } catch {
    return undefined;
  }
}
